<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
				<top-nevleft></top-nevleft>
             <b-col class="p-0">
				
				
			  
		
		<b-container fluid>
			<!-- <b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">WAITING</b-badge>
										<b-badge pill variant="success" v-else-if="row.value == 1">ACTIVE</b-badge>
										<b-badge pill variant="danger" v-else>REJECTED</b-badge>
									</template>
                                    <template v-slot:cell(thumbnail)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{row}}</b-img>
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="row.value.replace('_rg','_th')">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target),tabIndex=0"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
										<b-button pill variant="danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										
										<b-button pill variant="primary" class="mr-1 icon-btn" @click="$root.previewproduct(row.item, row.index)"><i class="fa fa-eye" aria-hidden="true"></i></b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>-->

			<b-container fluid>
				<b-row class="mb-1">
					<b-col>
						<b-row class="mb-3">
							<b-col cols="6">
							</b-col>
							<b-col cols="6" class="text-right">
								
								<b-button size="sm" variant="danger" @click="addVariation()" >Add Row</b-button>
								<!--<b-button size="sm" variant="danger" @click="addAttribute()" class="mr-2">Add Column</b-button> -->
							</b-col>
						</b-row>
						 <b-row no-gap>
							<b-col cols="1" class="px-1">
								<span class="font-sm p-2">Row</span>
							</b-col>
							<!-- <b-col cols="2" class="px-1 mb-2" v-for="item in selectedItem.variation_attributes" :key="item">
								<b-form-input :value="item" required size="sm" placeholder="Attribute name"></b-form-input>
							</b-col> -->
							<b-col cols="1" class="px-1">
								<span class="font-sm p-2">Column</span>
							</b-col>
							<!--<b-col cols="1" class="px-1">
								<span class="font-sm p-2">Sp.Price</span>
							</b-col>
							<b-col cols="1" class="px-1">
								<span class="font-sm p-2">Qty</span>
							</b-col>-->
							<b-col cols="1" class="px-1">
								<label class="font-sm">Delete</label>
							</b-col>
						</b-row> 
						<b-row v-for="(item, index) in selectedItem.variations" :key="item.id" class="mb-2" no-gap>
							<b-col cols="1" class="px-1">
								<b-form-input v-model="item.needRow"  required size="sm"></b-form-input>
							</b-col>
							<!-- <b-col cols="2" class="px-1" v-for="attritem in item.attributes" :key="attritem.id" >
								<b-form-input v-model="attritem.value" required size="sm"></b-form-input>
							</b-col> -->
							<b-col cols="1" class="px-1">
								<b-form-input v-model="item.needColumn" required size="sm" placeholder="0"></b-form-input>
							</b-col>
							<!--<b-col cols="1" class="px-1">
								<b-form-input v-model="item.special_price" required size="sm" placeholder="0"></b-form-input>
							</b-col>
							<b-col cols="1" class="px-1">
								<b-form-input v-model="item.qty" required size="sm" placeholder="0"></b-form-input>
							</b-col>-->
							<b-col cols="1" class="px-1">
								<b-button pill variant="danger" class="mr-1 icon-btn" @click="removeVariation(index)" size="sm"><b-icon scale="1.2" icon="trash" aria-hidden="true"></b-icon></b-button>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="1" class="px-1 text-right">
								<b-button pill variant="primary" class="mr-1 " @click="createTemplate()" size="sm">CreateTemplate</b-button>
							</b-col>
						</b-row>
						
						<!-- {{selectedItem.variations}} -->
					</b-col>
				</b-row>

</b-container>

		
		</b-container>
		<b-container>
		<b-row class="mb-4" v-for="rowItem in tamplateData" :key="rowItem.id">
						
							<!--<b-col  v-for="colItem in rowItem.needColumn" :key="colItem" > -->
							<b-col  v-for="colItem in parseInt(rowItem.needColumn)" :key="colItem" >
									<div class="pageview">
										<b-img :src="$root.MEDIAPATH+'images/600x318.jpg'" fluid-grow alt="Fluid-grow image" class="moreOfferImgHeight"></b-img>
										<div class="imginfo d-none d-md-block">
											<p class="title">{{colItem.title}}</p>
											<p class="subtitle">{{colItem.subtitle}}</p>
										</div>
										
									</div>
									
							
							</b-col>
		</b-row>
		</b-container>
			<!-- <b-container>
			<b-row class="mb-4" v-for="rowItem in pageData" :key="rowItem.id">
								<b-col  v-for="colItem in rowItem.children" :key="colItem" >
										<div class="pageview">
											<b-img :src="$root.MEDIAPATH+'images/600x318.jpg'" fluid-grow alt="Fluid-grow image" class="moreOfferImgHeight"></b-img>
											<div class="imginfo d-none d-md-block">
												<p class="title">{{colItem.title}}</p>
												<p class="subtitle">{{colItem.subtitle}}</p>
											</div>
											<div class="imginfo d-block d-sm-block d-md-none">
												<p class="title">Custom Design</p>
												<p class="subtitle">Genuine material</p>
											</div>
										</div>
										
								
								</b-col>
							</b-row>
			</b-container> -->
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		<product-preview :productviewlink="$root.productviewlink"></product-preview>
	</div>
	
</template>
<script>
 import Header from "@/components/header.vue";
//import Header from "@/components/seller/Header.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import Productpreview from "@/components/product-preview.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"product-preview": Productpreview,
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
			product_infState: {product_image_1:null,
						  product_image_2:null,
						  product_image_3:null,
						  product_image_4:null,
						  product_image_5:null,
						  },
			product_inforder: {
					order_1:1,
					order_2:2,
					order_3:3,
					order_4:4,
					order_5:5},
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'sellerapi/product-record',
			/* insertUrl: this.$root.WEBAPI+'sellerapi/product-insert', 
			*/
			updateUrl: this.$root.NEWAPIURL+'sellerapi/productupdatenew',
			insertnewUrl: this.$root.NEWAPIURL+'sellerapi/productinsertnew',
			deleteUrl: this.$root.WEBAPI+'sellerapi/product-delete',
			csvgenUrl: this.$root.WEBAPI+'sellerapi/product-csvgen',
			filteredCategory: [],
			category: [],
			brandlist: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'category', label: 'category' },
				{ key: 'sku', label: 'SKU' },
				{ key: 'thumbnail', label: 'Thumbnail',
					formatter: (value, key, item) => { 
						return item.image;
					}
				},
				{ key: 'price', label: 'Price', class: 'text-right',
					formatter: (value) => { 
						return this.$root.currency()+this.$root.tofixed(value,2);
					},
				},
				{ key: 'special_price', label: 'Spl.Price', class: 'text-right',
					formatter: (value) => { 
						if(value>0 || value != null ){
							return this.$root.currency()+this.$root.tofixed(value,2);
						}else{
							return '-n/a-';
						}
						
					},
				},
				{ key: 'commission', label: 'Commission', class: 'text-right',
					formatter: (value) => { 
						if(value == '' || value == 0){
							return value = 'N/A';
						}
						return value+'%';
					},
				},
                { key: 'stock_qty', label: 'Qty', class: 'text-right' },
				{ key: 'discount', label: 'Discount', class: 'text-right' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				title: '',
				short_description: '',
				description: '',
				sku: '',
				hsn_code: '',
				category: '',
				price: '',
				discount: '',
				product_type:1,
				stock_qty:'',
				stock_status:'',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""],
				status:'',
				commission:'',
				variation_attributes:[],
				variations:[],
				brand:'',
			},
			selectedItemState: {
				title: null,
				short_description: null,
				description:null,
				sku: null,
				hsn_code: null,
				category: null,
				price: null,
				discount: null,
				product_type: null,
				stock_qty:null,
				stock_status:null,
				product_data:{}, 
				tier_price:null, 
				status:null,
				commission:null,
				variation_attributes:null,
				variations:null,
				brand:null,
			},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				hsn_code: '',
				category: '',
				price: '',
				product_type: 1,
				stock_qty:'',
				stock_status:'',
				special_price: '',
				product_data:{},
				tier_price: [],
				gallery_images:["","","","",""],
                status: 0,
                commission: '',
				variation_attributes:[],
				variations:[],
				brand:'',
			},
			counterindex:1,
			deleteImage1:'',
			deleteImage2:'',
			deleteImage3:'',
			deleteImage4:'',
			deleteImage5:'',
			tabIndex: 0,
			commissionError:'Commission is required!',
			 pageData:[{"col":3,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c2":{"title":"title2","subtitle":"subtitle2","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c3":{"title":"title3","subtitle":"subtitle3","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c4":{"title":"title4","subtitle":"subtitle3","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."}}},{"col":2,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c2":{"title":"title2","subtitle":"subtitle2","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."}}},{"col":2,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."}}}],
			 tamplateData:[],
			
		};
	},
	methods: {
		
		onChangeCommission(){
			if(this.selectedItem.commission < 5 && this.selectedItem.commission != 0){
				//this.selectedItem.commission = 5;
			}
		},
		filterChildCategory(id, index, parentid){
			var self = this;
			var tab = '';
			for (let i = 0; i < index; i++) {
				tab += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
			}
			this.category.forEach(function(field){
				if(field.parent == id){
					var fieldid = field.id;
					if(parentid != 0){
						fieldid = parentid+','+field.id;
					}
					self.filteredCategory.push({ html: tab+field.title, title:field.title, position:field.position, parent:field.parent, value: fieldid });
					
					self.filterChildCategory(field.id, index+1, fieldid);
				}
			});
			return ;
		},
		addVariation(){
			//console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			//var uniqid = d.getTime();
			//var attributes = [];
			/*this.selectedItem.variation_attributes.forEach(function(attr){
				attributes.push({'id':++uniqid, 'label':attr, 'value': '', position: ''});
			}); */
			console.log('length:'+this.selectedItem.variations.length);
			var rowId =this.selectedItem.variations.length;
			var rowValue ='Row'+rowId;
			this.selectedItem.variations.push({'id':d.getTime(), 'needRow':rowValue,'needColumn': 0});
		},
		addAttribute(){
			/* var d = new Date();
			if(this.selectedItem.variation_attributes.length < 3){
				this.selectedItem.variation_attributes.push("");
				this.selectedItem.variations.forEach(function(variation){
					variation.attributes.push({"id":d.getTime(),"label":"","value":"","position":variation.attributes.length+1});
				});
			} */
		},
		removeVariation(i){
			this.selectedItem.variations.splice(i,1);
		},
		removeTierPrice(i){
			this.selectedItem.tier_price.splice(i,1);
		},
		addTierPrice(){
			console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			this.selectedItem.tier_price.push({'id':d.getTime(), 'min_qty':0, 'price':0});
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},

		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					self.category = response.data.result.category;
					self.brandlist = response.data.result.brandlist;
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		createTemplate(){
			this.tamplateData= this.selectedItem.variations;
		}
	}
}
</script>
<style lang="scss">
	.disabledTab{
      pointer-events: none;
  }
</style>